const TimetableSelector = () => {
  const form = document.getElementById("timetable-quick-select");

  if (form) {
    const select = form.getElementsByTagName("select")[0];

    select.addEventListener("change", e => {
      const url = e.target.value;

      if (url !== "") {
        window.location = url;
      }
    });
  }
};

export default TimetableSelector;
